import { useEffect, useMemo } from "react";

/**
 * Fetch dedicated form data once per form identity.
 *
 * Do NOT add hydrate, onBack, onReady, draft, patient, or currentUser to deps —
 * those change every render and caused infinite API loops (e.g. Patient Consent).
 */
export function useDedicatedFormLoadEffect(patientId, formId, isDraft, load) {
  useEffect(() => {
    let cancelled = false;
    const isCancelled = () => cancelled;

    void load(isCancelled);

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId, formId, isDraft]);
}

/** Stable session user — avoids new object identity on every render. */
export function useSessionUser() {
  return useMemo(
    () => JSON.parse(localStorage.getItem("currentUser") || "{}"),
    [],
  );
}
